/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1SerievideoVideoidLangsIdQueryResponse,
  GetApiV1SerievideoVideoidLangsIdPathParams,
  GetApiV1SerievideoVideoidLangsIdQueryParams,
  GetApiV1SerievideoVideoidLangsId401,
  GetApiV1SerievideoVideoidLangsId404,
  GetApiV1SerievideoVideoidLangsId500,
} from "../../types/serieVideoIdiomasController/GetApiV1SerievideoVideoidLangsId.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1SerievideoVideoidLangsId } from "../../clients/serieVideoIdiomasController/getApiV1SerievideoVideoidLangsId.ts";

export const getApiV1SerievideoVideoidLangsIdQueryKey = (
  videoId: GetApiV1SerievideoVideoidLangsIdPathParams["videoId"],
  id: GetApiV1SerievideoVideoidLangsIdPathParams["id"],
  params?: GetApiV1SerievideoVideoidLangsIdQueryParams,
) =>
  [
    {
      url: "/api/v1/serievideo/:videoId/langs/:id",
      params: { videoId: videoId, id: id },
    },
    ...(params ? [params] : []),
  ] as const;

export type GetApiV1SerievideoVideoidLangsIdQueryKey = ReturnType<
  typeof getApiV1SerievideoVideoidLangsIdQueryKey
>;

export function getApiV1SerievideoVideoidLangsIdQueryOptions(
  videoId: GetApiV1SerievideoVideoidLangsIdPathParams["videoId"],
  id: GetApiV1SerievideoVideoidLangsIdPathParams["id"],
  params?: GetApiV1SerievideoVideoidLangsIdQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1SerievideoVideoidLangsIdQueryKey(
    videoId,
    id,
    params,
  );
  return queryOptions<
    GetApiV1SerievideoVideoidLangsIdQueryResponse,
    ResponseErrorConfig<
      | GetApiV1SerievideoVideoidLangsId401
      | GetApiV1SerievideoVideoidLangsId404
      | GetApiV1SerievideoVideoidLangsId500
    >,
    GetApiV1SerievideoVideoidLangsIdQueryResponse,
    typeof queryKey
  >({
    enabled: !!(videoId && id),
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1SerievideoVideoidLangsId(videoId, id, params, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna uma tradução (idioma) de vídeo pelo seu identificador. **(Requer Authorization para autenticação)**
 * @summary Obter idioma do vídeo por ID (Requer Authorization para autenticação)
 * {@link /api/v1/serievideo/:videoId/langs/:id}
 */
export function useGetApiV1SerievideoVideoidLangsId<
  TData = GetApiV1SerievideoVideoidLangsIdQueryResponse,
  TQueryData = GetApiV1SerievideoVideoidLangsIdQueryResponse,
  TQueryKey extends QueryKey = GetApiV1SerievideoVideoidLangsIdQueryKey,
>(
  videoId: GetApiV1SerievideoVideoidLangsIdPathParams["videoId"],
  id: GetApiV1SerievideoVideoidLangsIdPathParams["id"],
  params?: GetApiV1SerievideoVideoidLangsIdQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1SerievideoVideoidLangsIdQueryResponse,
        ResponseErrorConfig<
          | GetApiV1SerievideoVideoidLangsId401
          | GetApiV1SerievideoVideoidLangsId404
          | GetApiV1SerievideoVideoidLangsId500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1SerievideoVideoidLangsIdQueryKey(videoId, id, params);

  const query = useQuery(
    {
      ...getApiV1SerievideoVideoidLangsIdQueryOptions(
        videoId,
        id,
        params,
        config,
      ),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1SerievideoVideoidLangsId401
      | GetApiV1SerievideoVideoidLangsId404
      | GetApiV1SerievideoVideoidLangsId500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
